import NotionIcon from "../../assets/components/sources/NotionIcon";

const NotionLogomark = ({ height }: { height: number }) => {
  return <NotionIcon height={height} />;
};

export default NotionLogomark;
